var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SReplicaSet = function SvgK8SReplicaSet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-8 9V5h8v8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1V3H4a1 1 0 0 1 1-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
export default SvgK8SReplicaSet;